<template>
  <div>
    <!-- desktop -->
    <div class="layout" v-if="!isMobile">
      <img class="bg" :src="`${$cdn}images/aside_bg.jpg`" alt="">
      <div class="search-con" @click="$router.push({path:'/search'})">
        <!-- <input placeholder="" type="text"> -->
        <div>部件故事</div>
        <img :src="`${$cdn}images/a-search.png`" alt="">
      </div>
      <ul class="aside">
        <li :class="{active:item.id===activeIdx}" v-for="(item,i) in asdie" :key="i" @click="handleItem(item)" >
          <sequence :img="`${$cdn}images/frame/${item.img}.png`" :name = "item.name" />
        </li>
      </ul>
      <div class="lyb" @click="$message()">
        <img :src="`${$cdn}images/icon_index_nav_guestbook@2x.png`" alt="">
        <span>留言板</span>
      </div>
    </div>

    <!-- mobile -->

    <!-- <div class="search-con" @click="$router.push({path:'/search'})" v-if="isMobile">
      
      <div>部件故事</div>
      <img :src="`${$cdn}images/a-search.png`" alt="">
    </div> -->

    <div class="mobileLayout" v-if="isMobile">

      <img class="bg" :src="`${$cdn}images/mobile/home_menu.png`" alt="">

      

      <ul class="aside">
        <li><img :src="`${$cdn}images/mobile/home_btn_video.png`" @click="$router.push({path:'/video'})"></li>
        <li><img :src="`${$cdn}images/mobile/home_btn_horse.png`" @click="$router.push({name:'Floorlist',params:{id:{}}})"></li>
        <li><img :src="`${$cdn}images/mobile/home_btn_history.png`" @click="$router.push({path:'/tunnel'})"></li>
        <li><img :src="`${$cdn}images/mobile/home_btn_catalog.png`" @click="$router.push({path:'/list'})"></li>
        <li><img :src="`${$cdn}images/mobile/home_btn_contact.png`" @click="$message()"></li>
      </ul>
    </div>
  </div>
</template>





<script>
import sequence from '@/components/sequence'
import browser from '@/utils/browser.js'

  let asdie = [
    {
      id:4,
      name:'介绍视频',
      img:'01',
      path:'/video'
    },
    {
      id:3,
      name:'自由漫游',
      img:'03',
      path:'/select'
    },
    {
      id:1,
      name:'时光隧道',
      img:'04',
      path:'/tunnel'
    },
    {
      id:2,
      name:'部件赏析',
      img:'02',
      path:'/story'
    }
  ]
export default {
  components:{
    sequence
  },
  data(){
    return {
      asdie,
      isMobile: browser.mobile
    }
  },
  computed:{
    activeIdx: {
      get: function () {
        return this.$route.meta.id
      },
      set: function () {
      }
    },
  },
  methods:{
    handleItem(item){
      this.$hideBroadcast()
      this.$router.push({path:item.path})
      this.activeIdx = item.id
    },
    mobileHandleClick(path) {
      this.$router.push({path:path})
    }
  }
}
</script>

<style lang="less" scoped>
input::placeholder {
    color: #F5EDE2 !important;
}

.mobileLayout {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 10vh;
  width: 100vw;
  background: #fff;
  box-shadow: -5px 0 10px rgba(0, 0, 0, 0.5);
  color: #fff;
  z-index: 999;
  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1;
  }

.search-con{
    border: 2px solid @sub-theme;
    border-radius: 28px;
    width: 80%;
    margin: 20px auto;
    position: relative;
    padding-left: 10px;
    cursor: pointer;
    >div{
      border: none;
      background: none;
      line-height: @inputH;
      height: @inputH;
      width: 90%;
      color: #F5EDE2 ;
      vertical-align: middle;
      color: #fff;
    }
    img{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 6px;
    }
  }

  .aside {
    list-style: none;
    display: flex;
    width: 100vw;
    height: 10vh;
    padding: 0 10px;
    align-items: center;
    justify-content: space-between;
    z-index: 199;
    position: relative;
    li {
      display: flex;
      

      img {
        width: 16vw;
        height: 100%;
        padding: 10px 5px 5px 5px;
      }
    }
  }
}

.layout{
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 200px;
  background: #fff;
  box-shadow: -5px 0 10px rgba(0, 0, 0, 0.5);
  color: #fff;
  z-index: 999;
  .bg{
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }
  .search-con{
    border: 2px solid @sub-theme;
    border-radius: 28px;
    width: 80%;
    margin: 20px auto;
    position: relative;
    padding-left: 10px;
    cursor: pointer;
    >div{
      border: none;
      background: none;
      line-height: @inputH;
      height: @inputH;
      width: 90%;
      color: #F5EDE2 ;
      vertical-align: middle;
      color: #fff;
    }
    img{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 6px;
    }
  }
  .aside{
    text-align: center;
    li{
      font-weight: bold;
      font-size: 20px;
      font-family: 'SY-bold';
      margin: 50px auto;
      cursor: pointer;
    }
    .active{
      color: @sub-theme;
    }
  }
  .lyb{
    width: 100%;
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    cursor: pointer;
    img{
      vertical-align: middle;
      width: 20px;
      margin-right: 10px;
      position: relative;
      top: -1px;
    }
    span{
      vertical-align: middle;
      display: inline-block;
      font-size: 14px;
    }
  }
}



// @media screen and (max-width: 500px) {
// .layout{
//   position: fixed;
//   left: 0;
//   bottom: 100px;
//   height: 100px;
//   width: 100%;
//   background: #fff;
//   /*box-shadow: -5px 0 10px rgba(0, 0, 0, 0.5);*/
//   color: #fff;
//   z-index: 999;

//     .aside{
//       li{
//         margin: 30px auto;
//       }
//     }
//   }
// }

@media screen and (max-width: 1400px) {
.layout{
    .aside{
      li{
        margin: 30px auto;
      }
    }
  }
}

</style>

